import NoPosts from 'components/Community/UsersGallery/NoPosts/NoPosts';

export default NoPosts;
